<div class="px-4">
  @if (loading()) {
    <div class="text-center" i18n="@@viewCompanyLoading">Loading...</div>
  } @else if (error()) {
    <div class="text-center text-red-500">{{ error() }}</div>
  } @else if (company()) {
    <div class="flex flex-col gap-4 pb-6">
      <h2 class="text-primary font-['Inter'] text-2xl font-semibold">{{ getLocalizedTitle(company()) }}</h2>

      <div class="mb-4 flex flex-col gap-6 rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <div class="grid grid-cols-4 gap-6">
          <div class="group relative">
            <label
              for="productName"
              class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3">
              Product Name
            </label>
            <div class="relative">
              <input
                type="text"
                id="productName"
                name="productName"
                [(ngModel)]="filters.productName"
                placeholder="Product Name"
                class="w-full rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none placeholder:text-gray-300 hover:border-gray-600 focus:border-black ltr:pr-4 ltr:pl-10 rtl:pr-10 rtl:pl-4" />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="absolute top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400 transition-colors group-focus-within:text-black group-hover:text-gray-600 ltr:left-3 rtl:right-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
          </div>

          <div class="group relative">
            <label
              for="categoryId"
              class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3">
              Category
            </label>
            <div class="relative">
              <select
                name="categoryId"
                id="categoryId"
                [(ngModel)]="filters.categoryId"
                class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10">
                <option [ngValue]="undefined">Default</option>
                @if (categories()) {
                  @for (cat of categories()!.list; track cat.id) {
                    <option [value]="cat.id">{{ getLocalizedTitle(cat) }}</option>
                  }
                }
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-black ltr:right-3 rtl:left-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          <div class="group relative">
            <label
              for="subCategoryId"
              class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3">
              Sub Category
            </label>
            <div class="relative">
              <select
                name="subCategoryId"
                id="subCategoryId"
                [(ngModel)]="filters.subCategoryId"
                class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10">
                <option [ngValue]="undefined">Default</option>
                @if (subCategories()) {
                  @for (subCat of subCategories()!.list; track subCat.id) {
                    <option [value]="subCat.id">{{ getLocalizedTitle(subCat) }}</option>
                  }
                }
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-black ltr:right-3 rtl:left-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

          <div class="group relative">
            <label
              class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 ltr:left-3 rtl:right-3">
              MFG Company
            </label>
            <div class="relative">
              <select
                [(ngModel)]="filters.mfgCompany"
                class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 outline-none ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10">
                <option [value]="company()?.id">{{ getLocalizedTitle(company()) }}</option>
              </select>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-black ltr:right-3 rtl:left-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-10">
          <div class="flex flex-col gap-3">
            <div class="flex items-center justify-between px-1">
              <label class="text-[14px] font-bold text-gray-800">People Price</label>
              <div class="flex items-center gap-1 text-[13px] font-bold text-gray-800" dir="ltr">
                <span>EGP</span>
                <span>{{ filters.peoplePriceFrom }} - {{ filters.peoplePriceTo }}</span>
              </div>
            </div>
            <div
              class="range-slider-container"
              [ngStyle]="getSliderTrackStyle(filters.peoplePriceFrom, filters.peoplePriceTo)">
              <input
                type="range"
                min="0"
                max="1000"
                step="10"
                [(ngModel)]="filters.peoplePriceFrom"
                (input)="validateRange('people')"
                class="range-input" />
              <input
                type="range"
                min="0"
                max="1000"
                step="10"
                [(ngModel)]="filters.peoplePriceTo"
                (input)="validateRange('people')"
                class="range-input" />
            </div>
          </div>

          <div class="flex flex-col gap-3">
            <div class="flex items-center justify-between px-1">
              <label class="text-[14px] font-bold text-gray-800">Pharmacy Price</label>
              <div class="flex items-center gap-1 text-[13px] font-bold text-gray-800" dir="ltr">
                <span>EGP</span>
                <span>{{ filters.pharmacyPriceFrom }} - {{ filters.pharmacyPriceTo }}</span>
              </div>
            </div>
            <div
              class="range-slider-container"
              [ngStyle]="getSliderTrackStyle(filters.pharmacyPriceFrom, filters.pharmacyPriceTo)">
              <input
                type="range"
                min="0"
                max="1000"
                step="10"
                [(ngModel)]="filters.pharmacyPriceFrom"
                (input)="validateRange('pharmacy')"
                class="range-input" />
              <input
                type="range"
                min="0"
                max="1000"
                step="10"
                [(ngModel)]="filters.pharmacyPriceTo"
                (input)="validateRange('pharmacy')"
                class="range-input" />
            </div>
          </div>
        </div>

        <div class="mt-4 flex justify-between gap-4">
          <div class="flex flex-1 gap-4">
            <div class="group relative max-w-[200px] flex-1">
              <label
                for="orderBy"
                class="absolute -top-2 z-10 bg-white px-1 text-[12px] font-semibold text-gray-700 transition-colors group-focus-within:text-black group-hover:text-gray-900 ltr:left-3 rtl:right-3">
                Sort By
              </label>
              <div class="relative">
                <select
                  name="orderBy"
                  id="orderBy"
                  [(ngModel)]="filters.orderBy"
                  class="w-full appearance-none rounded-[10px] border border-gray-400 bg-white py-2.5 text-[14px] text-gray-700 transition-colors outline-none hover:cursor-pointer hover:border-gray-600 focus:border-black ltr:pr-10 ltr:pl-4 rtl:pr-4 rtl:pl-10">
                  <option value="productName">Product Title</option>
                  <option value="CREATED_DATE">Creation Date</option>
                </select>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="pointer-events-none absolute top-1/2 h-5 w-5 -translate-y-1/2 text-black ltr:right-3 rtl:left-3"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
            <button
              (click)="toggleSortOrder()"
              class="rounded-[10px] border border-gray-400 px-4 py-2 text-[14px] font-[500] text-gray-700 transition-colors hover:cursor-pointer hover:border-gray-600 hover:bg-gray-50 focus:border-black focus:outline-none">
              {{ getLocalizedSortOrder() }}
            </button>
          </div>
          <div class="flex items-end justify-end gap-3">
            <button
              (click)="resetFilters()"
              class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-8 py-2 text-[13px] font-[500] transition-colors hover:cursor-pointer">
              <span i18n="@@adminProductsResetButton">Clear</span>
            </button>
            <button
              (click)="applyFilters()"
              class="bg-primary hover-bg-primary-hover rounded-[6px] px-8 py-2 text-[13px] font-[500] text-white transition-colors hover:cursor-pointer">
              Apply
            </button>
          </div>
        </div>
      </div>

      <div class="grid w-full grid-cols-4 gap-4 px-2">
        @for (product of paginatedProducts(); track product.id) {
          <div
            class="group relative flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white transition-all hover:cursor-pointer hover:shadow-lg">
            <div class="relative flex h-48 w-full items-center justify-center bg-gray-50">
              @if (product.discount) {
                <div class="bg-primary absolute top-0 left-0 z-10 rounded-xl rounded-tr-none rounded-bl-none px-2 py-1">
                  <span class="font-['Inter'] text-xs font-semibold text-white">{{ product.discount }}% off</span>
                </div>
              }
              <div class="absolute top-4 right-4 z-10 flex flex-col gap-2 transition-opacity duration-300">
                <button
                  (click)="onAddToWishlist(product)"
                  class="hover-text-primary flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white text-gray-500 shadow-sm transition-all hover:scale-110 active:scale-95">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                      stroke="currentColor"
                      stroke-width="1.5"
                      fill="none" />
                  </svg>
                </button>
                <button
                  (click)="onAddToCart(product)"
                  class="hover-text-primary flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-white text-gray-500 shadow-sm transition-all hover:scale-110 active:scale-95">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="square"
                      stroke-width="1.5"
                      d="M1 2h3l3 11m0 0h12l3-9M7 13l-1 4h15M7 21a1 1 0 1 1-2 0a1 1 0 0 1 2 0Zm14 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0ZM13 3v3m0 0v3m0-3h3m-3 0h-3" />
                  </svg>
                </button>
              </div>
              <img [src]="product.image" [alt]="product.name" class="h-3/4 w-3/4 object-contain" />
            </div>
            <div class="flex flex-1 flex-col px-6 py-4">
              <h3 class="truncate font-['Inter'] text-base font-medium text-gray-900" [title]="product.name">
                {{ product.name }}
              </h3>
              <div class="mt-1 flex items-center justify-between">
                <p class="font-['Inter'] text-xs text-gray-500">{{ product.manufacturer }}</p>
                <p class="font-['Inter'] text-xs text-gray-500">EXP: {{ product.expires }}</p>
              </div>
              <div class="my-4 h-px w-full bg-gray-200"></div>
              <div class="grid grid-cols-2 gap-4">
                <div class="flex items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 4 42 42"
                    class="flex-shrink-0">
                    <g class="fill-primary">
                      <path
                        d="M18.305 13c-.057-1.61-.011-3.315.556-4.647c.299-.7.73-1.266 1.354-1.667c.627-.402 1.527-.686 2.843-.686c1.475 0 2.704.536 3.584 1.094c.437.278.778.555 1.007.76a6 6 0 0 1 .31.3l.01.01v.001a1 1 0 0 0 1.496-1.328l-.735.65c.735-.65.733-.652.733-.652v-.001l-.004-.004l-.01-.01a3 3 0 0 0-.122-.13a8 8 0 0 0-.343-.325a10 10 0 0 0-1.27-.96C26.624 4.716 25.024 4 23.058 4c-1.606 0-2.903.349-3.923 1.003c-1.023.657-1.69 1.57-2.114 2.566c-.738 1.733-.774 3.798-.718 5.431H11c-.553 0-1.006.45-.943.998c.615 5.38 6.16 9.643 13.058 9.98V32h2v-8.034a17 17 0 0 0 4.87-1.02q.015.172.015.357c0 .762-.623 1.674-1.901 2.466a8.6 8.6 0 0 1-2.099.924v2.066a10.6 10.6 0 0 0 3.151-1.29C30.624 26.56 32 25.123 32 23.304c0-.41-.038-.815-.123-1.208c3.367-1.804 5.68-4.732 6.066-8.097c.063-.548-.391-.998-.943-.998z" />
                      <path
                        d="M30 39c0 1.165-.36 2.188-1.019 3H32v2H16v-2h7.115v-4h2v3.914c.802-.131 1.436-.404 1.892-.763c.625-.49.993-1.196.993-2.151s-.368-1.66-.993-2.151c-.65-.512-1.662-.85-3.007-.85c-1.517 0-3.2-.119-4.531-.71c-.684-.304-1.315-.75-1.773-1.403c-.462-.66-.696-1.461-.696-2.386s.234-1.726.696-2.386c.458-.653 1.09-1.099 1.773-1.403c.76-.338 1.637-.522 2.531-.617v2.013c-.658.083-1.242.22-1.719.432c-.441.196-.747.438-.946.722c-.194.277-.335.664-.335 1.239s.14.962.335 1.239c.199.284.505.526.946.722c.92.409 2.236.539 3.719.539c1.654 0 3.144.413 4.243 1.276C29.368 36.16 30 37.455 30 39" />
                    </g>
                  </svg>
                  <div class="flex flex-col">
                    <span class="font-['Inter'] text-xs whitespace-nowrap text-gray-500">Pharmacy Price</span>
                    <div class="flex items-baseline gap-1">
                      <span class="text-base font-bold text-gray-900">{{ product.pharmacyPrice }}</span>
                      <span class="text-xs font-medium text-gray-900">EGP</span>
                    </div>
                  </div>
                </div>
                <div class="flex items-center gap-2">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="text-primary">
                    <path
                      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                    <path
                      d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <div class="flex flex-col">
                    <span class="font-['Inter'] text-xs whitespace-nowrap text-gray-500">People Price</span>
                    <div class="flex items-baseline gap-1">
                      <span class="text-lg font-bold text-gray-900">{{ product.peoplePrice }}</span>
                      <span class="text-xs font-medium text-gray-900">EGP</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="mt-2 flex items-center justify-center gap-2">
        <button
          (click)="changePage(currentPage() - 1)"
          [disabled]="currentPage() == 1"
          class="flex h-10 w-10 items-center justify-center rounded-full text-black enabled:hover:bg-gray-100 disabled:opacity-50">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="rtl:rotate-180">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
        @for (page of pagesArray; track page) {
          <button
            (click)="changePage(page)"
            [class.bg-pagination-bg]="page == currentPage()"
            [class.text-primary]="page == currentPage()"
            [class.font-bold]="page == currentPage()"
            class="flex h-10 w-10 items-center justify-center rounded-full text-lg font-medium transition-colors">
            {{ page }}
          </button>
        }
        <button
          (click)="changePage(currentPage() + 1)"
          [disabled]="currentPage() == totalPages()"
          class="flex h-10 w-10 items-center justify-center rounded-full text-black enabled:hover:bg-gray-100 disabled:opacity-50">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="rtl:rotate-180">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>
  }
</div>
